import { React, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InterviewService } from "../../../../services/InterviewService";
import { CVDocumentLine } from "./CVDocumentLine";

export function CVDocuments({
  interviewId,
  updateDocumentsGrid,
  disabled,
  refreshDocuments
}) {
  const { t } = useTranslation();
  const [cvDocuments, setCVDocuments] = useState([]);
  const [isAccordionCollapsed, setIsAccordionCollapsed] = useState(true);

  useEffect(() => {
    getcvs();
  }, [updateDocumentsGrid]);

  function getcvs() {
    if (interviewId > 0) {
      InterviewService.getCVs(Number(interviewId)).then((docs) => {
        if (docs !== undefined && docs.length > 0) {
          setCVDocuments(docs);
        } else {
          setCVDocuments([]);
        }
      });
    }
  }

  return (
    <>
      {((disabled && cvDocuments.length > 0) || !disabled) && (
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingCvs">
            {!disabled ? (
              <button
                className={`accordion-button ${
                  isAccordionCollapsed && cvDocuments.length === 0
                    ? "collapsed"
                    : isAccordionCollapsed && cvDocuments.length > 0
                    ? ""
                    : !isAccordionCollapsed && cvDocuments.length > 0
                    ? "collapsed"
                    : isAccordionCollapsed
                    ? "collapsed"
                    : ""
                }`}
                type="button"
                data-bs-target="#collapseCvs"
                aria-expanded="true"
                aria-controls="collapseCvs"
                onClick={() => setIsAccordionCollapsed(!isAccordionCollapsed)}
              >
                CVs
              </button>
            ) : (
              <label className={"accordion-button label-documents"}>CVs</label>
            )}
          </h2>
          {!disabled ? (
            <div
              id="collapseCvs"
              className={`accordion-collapse ${
                isAccordionCollapsed && cvDocuments.length === 0
                  ? "collapse"
                  : isAccordionCollapsed && cvDocuments.length > 0
                  ? ""
                  : !isAccordionCollapsed && cvDocuments.length > 0
                  ? "collapse"
                  : isAccordionCollapsed
                  ? "collapse"
                  : ""
              }`}
              aria-labelledby="headingCvs"
              data-bs-parent="#accordionFlushDocuments"
            >
              <div class="accordion-body table-wrap documents-tab-cv margim-table-documents">
                <table className="table mt-2">
                  <thead>
                    <th className="languages">{t("Language")}</th>
                    <th className="description">{t("Description")}</th>
                    <th className="updated-date">{t("Updated on")}</th>
                    <th className="actions">{t("Actions")}</th>
                  </thead>
                  <tbody>
                    <CVDocumentLine
                      docs={cvDocuments}
                      interviewId={interviewId}
                      deleteCallBack={getcvs}
                      disabled={disabled}
                      refreshDocuments={refreshDocuments}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div
              id="collapseCvs"
              className="accordion-collapse"
              aria-labelledby="headingCvs"
              data-bs-parent="#accordionFlushDocuments"
            >
              <div class="accordion-body table-wrap documents-tab-cv margim-table-documents">
                <table className="table mt-2">
                  <thead>
                    <th className="languages">{t("Language")}</th>
                    <th className="description">{t("Description")}</th>
                    <th className="updated-date">{t("Updated on")}</th>
                    <th className="actions">{t("Actions")}</th>
                  </thead>
                  <tbody>
                    <CVDocumentLine
                      docs={cvDocuments}
                      interviewId={interviewId}
                      deleteCallBack={getcvs}
                      disabled={disabled}
                      refreshDocuments={refreshDocuments}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
